const $ = require('jquery');

// Make it easier to use jQuery from the console
window.$ = $;

require('./components/button.js');
require('./components/form.js');
require('./components/map.js');
require('./components/hero.js');
require('./components/scroll-on-click.js');
//require('./components/hp-hero-button.js');
//require('./components/jump-menu.js');
